import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText,
} from '../../../components/suppliers-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
  //   Header: () => <HeaderLabel>คำนำหน้า</HeaderLabel>,
  //   accessor: 'prefix',
  //   sortable: false,
  //   filterable: false,
  //   Cell: props => <CellText>{props.value}</CellText>,
  //   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  //   filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  //   width: 100,
  //   margin: '0 50px',
  // }, {
    Header: () => <HeaderLabel>ชื่อผู้ผลิต</HeaderLabel>,
    accessor: 'name',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 350,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>เบอร์โทรศัพท์สำนักงาน</HeaderLabel>,
    accessor: 'officeTel',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อผู้ติดต่อ</HeaderLabel>,
    accessor: 'contactName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 350,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>เบอร์โทรศัพท์ผู้ติดต่อ</HeaderLabel>,
    accessor: 'contactPhoneNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
